/*---
hideFromSearchEngines: true
---*/
import { prefixUrl } from '@mapbox/batfish/modules/prefix-url';
import { createRedirect } from '@mapbox/dr-ui/helpers/create-redirect';

export default createRedirect(prefixUrl('/example/queryrenderedfeatures/'));
